// Taboola defaults for rugby, all editions.
//
// Notes:
// 1. '*_webview' only used in webview mode.
// 2. 'publisher_webview' gets 'ios' or 'android' appended to it on those platforms.
// 3. 'publisher_webview' gets 'indiaios' or 'indiaandroid' appended to it on those platforms in India.
// 4. 'mode_webview' gets '-iOS' or '-Android' appended to it on those platforms.
// 5. 'mode_webview' gets 'India-iOS' or 'India-Android' appended to it on those platforms in India.
// 6. 'commentary' => 'gamepackage'
// 7. 'conversation' => 'gamepackage'
// 8. 'game' => 'gamepackage'
// 9. 'lineups' => 'gamepackage'
// 10. 'match' => 'gamepackage'
// 11. 'matchstats' => 'gamepackage'
// 12. 'playerstats' => 'gamepackage'
// 13. 'preview' => 'article' (only available via gamepackage in Reduxion)
// 14. 'report' => 'article' (only available via gamepackage in Reduxion)
// 15. 'team' => 'clubhouse', which only has a right-rail placement.

export default {
  'publisher_webview': 'espnappsnetwork-espn',
  'commentary': {
    'type': 'category',
    'mode': 'thumbnails-3x1-b',
    'mode_webview': 'thumbnails-2x2-ESPN',
    'container': 'taboola-below-section-front-thumbnails',
    'container_webview': 'taboola-below-section-front-thumbnails',
    'target_type': 'mix'
  },
  'conversation': {
    'type': 'category',
    'mode': 'thumbnails-3x1-b',
    'mode_webview': 'thumbnails-2x2-ESPN',
    'container': 'taboola-below-section-front-thumbnails',
    'container_webview': 'taboola-below-section-front-thumbnails',
    'target_type': 'mix'
  },
  'game': {
    'type': 'category',
    'mode': 'thumbnails-3x1-b',
    'mode_webview': 'thumbnails-2x2-ESPN',
    'container': 'taboola-below-section-front-thumbnails',
    'container_webview': 'taboola-below-section-front-thumbnails',
    'target_type': 'mix'
  },
  'lineups': {
    'type': 'category',
    'mode': 'thumbnails-3x1-b',
    'mode_webview': 'thumbnails-2x2-ESPN',
    'container': 'taboola-below-section-front-thumbnails',
    'container_webview': 'taboola-below-section-front-thumbnails',
    'target_type': 'mix'
  },
  'match': {
    'type': 'category',
    'mode': 'thumbnails-3x1-b',
    'mode_webview': 'thumbnails-2x2-ESPN',
    'container': 'taboola-below-section-front-thumbnails',
    'container_webview': 'taboola-below-section-front-thumbnails',
    'target_type': 'mix'
  },
  'matchstats': {
    'type': 'category',
    'mode': 'thumbnails-3x1-b',
    'mode_webview': 'thumbnails-2x2-ESPN',
    'container': 'taboola-below-section-front-thumbnails',
    'container_webview': 'taboola-below-section-front-thumbnails',
    'target_type': 'mix'
  },
  'playerstats': {
    'type': 'category',
    'mode': 'thumbnails-3x1-b',
    'mode_webview': 'thumbnails-2x2-ESPN',
    'container': 'taboola-below-section-front-thumbnails',
    'container_webview': 'taboola-below-section-front-thumbnails',
    'target_type': 'mix'
  },
  'preview': {
    'type': 'category',
    'mode': 'thumbnails-3x1-b',
    'mode_webview': 'thumbnails-2x2-ESPN',
    'container': 'taboola-below-section-front-thumbnails',
    'container_webview': 'taboola-below-section-front-thumbnails',
    'target_type': 'mix'
  },
  'report': {
    'type': 'category',
    'mode': 'thumbnails-3x1-b',
    'mode_webview': 'thumbnails-2x2-ESPN',
    'container': 'taboola-below-section-front-thumbnails',
    'container_webview': 'taboola-below-section-front-thumbnails',
    'target_type': 'mix'
  },
  'team': {
    'right-rail' : {
      'type': 'other',
      'mode': 'thumbnails-1x3',
      'container': 'taboola-right-rail-thumbnails',
      'target_type': 'mix'
    }
  }
}



// WEBPACK FOOTER //
// ../app/lib/utils/editions/config/taboola.js